export default (product) => {
  const modifiedProduct = { ...product };

  if (product?.traits?.colors?.colorMap && !Array.isArray(product?.traits?.colors?.colorMap)) {
    modifiedProduct.traits.colors.colorMap = Object.values(product.traits.colors.colorMap);
  }

  return modifiedProduct;
};
